import React from 'react';
import { View } from 'react-native';

export default function AccessibilityWrapper({
  children,
}: React.PropsWithChildren<{ fieldsRefs: unknown[] }>) {
  return <View>{children}</View>;
}
